export default __webpack_public_path__ + "static/avantis-f20e298e7fe719de94f6b07a69c60589.svg";